export class CustomError extends Error {
  constructor(message = "") {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "CustomError";
  }
}
